module.exports = "/wwwroot/img/location_page.png?ver=c934478f";